import { IAppConfig } from '../interfaces/app-config';
import { Injectable } from '@angular/core';

@Injectable()
export class AppConfig {
    public settings: IAppConfig | undefined;
    load() {
        const appConfFile = `assets/config.json`;
        return new Promise<void>((resolve, reject) => {
            // App Config
        fetch(appConfFile)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            }).then((response: IAppConfig) => {
                this.settings = response;
                resolve(); 
            })
            .catch(error => {
                console.error(`Error loading app config: ${error}`);
                reject(error);
            });
        });
    }
}